import { styled, type SxProps, type Theme } from "@mui/material/styles";

export const SWATCH_SIZE = 24;

export const PICKER_SX: SxProps<Theme> = {
  position: "relative",
  display: "flex",
  flexShrink: 0,
  width: SWATCH_SIZE,
  height: SWATCH_SIZE,
  mr: 1.25,
};

/** The native picker sits invisibly over the swatch, so a click on the swatch opens it in place. */
export const NATIVE_PICKER_SX: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  m: 0,
  p: 0,
  border: 0,
  opacity: 0,
  cursor: "pointer",
  "&:disabled": { cursor: "default" },
};

export const Swatch = styled("span", {
  shouldForwardProp: (prop) => prop !== "swatchColor",
})<{ swatchColor: string }>(({ swatchColor }) => ({
  width: SWATCH_SIZE,
  height: SWATCH_SIZE,
  borderRadius: 2,
  backgroundColor: swatchColor,
}));
